import {
	IconAlertCircle,
	IconBellOff,
	IconCreditCard,
	IconFirecracker,
	IconMessageCircle,
	IconMoney,
	IconSearch,
	IconStar,
	IconVelocimeter,
} from "@consumidor-positivo/aurora";

export const notifyIcons = {
	score: <IconVelocimeter />,
	debts: <IconMoney />,
	lookout: <IconSearch />,
	offers: <IconCreditCard />,
	"negative-debts": <IconAlertCircle />,
	objective: <IconStar />,
	generic: <IconMessageCircle />,
	empty: <IconBellOff />,
	news: <IconFirecracker />,
};
